import { Email, PhoneCall, Whatsapp } from '@insify/design-system/line-icons';
import { useTranslation } from 'react-i18next';

import { useCoBranding } from './useCoBranding';

const iconTypeToIcon = {
  'phone-call': <PhoneCall />,
  whatsapp: <Whatsapp />,
  email: <Email />,
};

export const useContactOptions = () => {
  const { t } = useTranslation(['funnel']);
  const { contactOptions, contactOptionsDescription, hasCoBranding } = useCoBranding();

  if (hasCoBranding || (contactOptions?.items?.length ?? 0) !== 0) {
    return {
      contactOptions: contactOptions.items.map(({ iconType, text, link }) => ({
        icon: iconTypeToIcon[iconType],
        label: text,
        link,
        trackingId: iconType,
      })),
      contactOptionsDescription,
    };
  }

  return {
    contactOptions: [
      {
        icon: <PhoneCall />,
        label: t('funnel:sidebar_default_call_us'),
        link: t('funnel:sidebar_default_call_us_link'),
        trackingId: 'phone-call',
      },
    ],
  };
};
